<template>
  <CBox class="projectContainer" mt="6vw">
    <CBox
      v-if="projects.length"
      d="flex"
      class="projectBox"
      justifyContent="space-evenly"
      flexWrap="wrap"
    >
      <CBox class="projects" v-for="project in projects" :key="project.heading">
        <ProjectCard
          width="20vw"
          height="32vw"
          :heading="project.heading"
          :subHeading="project.subHeading"
          borderRadius="1vw"
          imageWidth="20vw"
          imageHeight="20vw"
          :imageSrc="project.imageSrc"
          :projectLink="project.projectLink"
        />
      </CBox>
    </CBox>
    <CBox
      class="launchPhoto"
      pos="absolute"
      left="60vw"
      top="60vw"
      transform="rotate(-7deg)"
    >
      <CImage :src="getLaunchPhoto" opacity="0.15" size="9vw" />
    </CBox>
    <CBox
      class="groupPhoto"
      pos="absolute"
      left="29vw"
      top="0vw"
      transform="rotate(20deg)"
    >
      <CImage :src="getGroupPhoto" opacity="0.15" size="10vw" />
    </CBox>
  </CBox>
</template>

<script>
import { CBox, CImage } from "@chakra-ui/vue";
import ProjectCard from "../components/ProjectCard.vue";
import FluffyProjectPhoto from "../assets/img/fluffyProject.jpeg";
import WebicodeProjectPhoto from "../assets/img/webicodeProject.jpeg";
import TwitterCloneProjectPhoto from "../assets/img/twitterCloneProject.jpeg";
import CryptoNotesProjectPhoto from "../assets/img/cryptoNotesProject.jpeg";
import SmartCandidateManagementProjectPhoto from "../assets/img/smartCandidateManagementProject.png";
import TicTacToeProjectPhoto from "../assets/img/tictactoeProject.jpeg";
import Launch from "../assets/img/Launch.png";
import Group from "../assets/img/Group.png";

export default {
  name: "WorkExperience",
  components: {
    CBox,
    CImage,
    ProjectCard,
  },
  computed: {
    getFluffyProjectPhoto() {
      return FluffyProjectPhoto;
    },
    getWebicodeProjectPhoto() {
      return WebicodeProjectPhoto;
    },
    getTwitterCloneProjectPhoto() {
      return TwitterCloneProjectPhoto;
    },
    getCryptoNotesProjectPhoto() {
      return CryptoNotesProjectPhoto;
    },
    getSmartCandidateManagementProjectPhoto() {
      return SmartCandidateManagementProjectPhoto;
    },
    getTicTacToeProjectPhoto() {
      return TicTacToeProjectPhoto;
    },
    getLaunchPhoto() {
      return Launch;
    },
    getGroupPhoto() {
      return Group;
    },
  },
  data() {
    return {
      projects: [
        {
          heading: "Fluffy",
          subHeading:
            "Fluffy is an imaginary movie renting service. It has all CRUD operation, authentication and authorization for the user and user-roles.",
          imageSrc: FluffyProjectPhoto,
          projectLink: "https://fierce-inlet-82973.herokuapp.com/movies",
        },
        {
          heading: "WebiCode",
          subHeading:
            "A quick online code editor for HTML, CSS and JavaScript.",
          imageSrc: WebicodeProjectPhoto,
          projectLink: "https://github.com/kishankhirasariya/WebiCode",
        },
        {
          heading: "Twitter Clone",
          subHeading:
            "I build this project solely for the implement what I learn. It has also an ability to post tweets.",
          imageSrc: TwitterCloneProjectPhoto,
          projectLink: "https://github.com/kishankhirasariya/twitter-clone",
        },
        {
          heading: "CryptoNotes",
          subHeading:
            "It is an android note-taking application for your notes with cryptographic algorithm for privacy and security.",
          imageSrc: CryptoNotesProjectPhoto,
          projectLink: "https://github.com/kishankhirasariya/CryptoNotes",
        },
        {
          heading: "Smart Candidate Management",
          subHeading:
            "This project is all about managing the details of candidates with the help of database with user authentication.",
          imageSrc: SmartCandidateManagementProjectPhoto,
          projectLink: null,
        },
        {
          heading: "Tic Tac Toe",
          subHeading:
            "I automate the opponent player of Tic Tac Toe. Used artificial intelligence algorithm to play the best turn and convert it to be unbeatable.",
          imageSrc: TicTacToeProjectPhoto,
          projectLink: null,
        },
      ],
    };
  },
};
</script>

<style>
@media screen and (max-width: 480px) {
  .projectContainer {
    margin-top: 10vh;
  }
  .projectBox {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .groupPhoto {
    left: 86vw;
    top: 20vh;
  }
  .launchPhoto {
    left: 42vw;
    top: 60vh;
  }
}

@font-face {
  font-family: "Ubuntu";
  src: local("Ubuntu"),
    url(../assets/fonts/Ubuntu-Regular.ttf) format("truetype");
}
</style>
